var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_DimensionsEntry"),
        width: "1030px",
        top: "2vh",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticStyle: { width: "100%" } }, [
        _c(
          "div",
          { staticClass: "form-row grid-list" },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "100px", "label-position": "left" } },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c("span", { staticStyle: { "font-size": "17px" } }, [
                      _vm._v(_vm._s(_vm.$t("Warehouse.CargoDetails")))
                    ]),
                    _c("el-form-item", { staticClass: "auto-width" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.openImperial,
                              expression: "!openImperial"
                            }
                          ],
                          staticClass: "title-row",
                          staticStyle: { display: "flex", "text-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_NetGrossWeight")
                                ) + "(KG)："
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.weightSum))
                              ]),
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_GrossWeight3")
                                  ) +
                                  ": "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.grossWeightSum) + ")")
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                  "(KG): "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.chargedWeightSum))
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Quantity")) + ": "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.quantitySum))
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Cubage")) + ": "),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.cubageSum))
                              ])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.openImperial,
                              expression: "openImperial"
                            }
                          ],
                          staticClass: "title-row",
                          staticStyle: { display: "flex", "text-align": "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "200px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_NetGrossWeight")
                                ) + "(LB)："
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.weightSumImperial))
                              ]),
                              _vm._v(
                                "(" +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_GrossWeight3")
                                  ) +
                                  ": "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(
                                  _vm._s(_vm.form.grossWeightSumImperial) + ")"
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                  "(LB): "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(
                                  _vm._s(_vm.form.chargedWeightSumImperial)
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Quantity")) + ": "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.quantitySum))
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "12px",
                                "font-weight": "normal",
                                color: "#404144",
                                "white-space": "nowrap",
                                width: "130px",
                                "text-align": "right"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.Cubage")) + "(CFT): "
                              ),
                              _c("span", { staticStyle: { color: "blue" } }, [
                                _vm._v(_vm._s(_vm.form.cubAgeSumImperial))
                              ])
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                ),
                _c("cargo-ag-grid", {
                  ref: "goodsTable",
                  staticStyle: { height: "200px", "padding-top": "5px" },
                  attrs: {
                    "config-module": "9300012",
                    "grid-options": _vm.detailList.goodGridOptions,
                    "column-defs": _vm.goodsColumn,
                    "row-data": _vm.form.warehouseInDetailList || []
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.detailList.gridApi = params.api
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "padding-top": "5px" } },
          [
            _c(
              "el-form",
              { attrs: { "label-width": "100px", "label-position": "right" } },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_PackingCondition")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: _vm.form.packingCondition,
                              filterable: "",
                              clearable: ""
                            },
                            on: { change: _vm.packingConditionHandler }
                          },
                          _vm._l(_vm.PACKING_CONDITION_LIST, function(
                            item,
                            index
                          ) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_SpecialHandling")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: _vm.form.specialHandling,
                              filterable: "",
                              clearable: ""
                            },
                            on: { change: _vm.specialHandlingHandler }
                          },
                          _vm._l(_vm.SPECIAL_HANDLING_LIST, function(
                            item,
                            index
                          ) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label:
                                  _vm.$store.getters.language === "zh"
                                    ? item.chineseName
                                    : item.englishName,
                                value: item.code
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              height: "50%",
              "padding-top": "5px",
              border: "2px solid transparent"
            }
          },
          [
            _c("tab-warehousing-charge", {
              ref: "tabCharges",
              attrs: {
                "warehouse-in-uuid": _vm.uuid,
                action: "edit",
                "show-ar": false
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.saveHandler(false)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Save")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveDoneHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveDone")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      ),
      _vm.dimensionsDialog.visible
        ? _c("dimensions-dialog", {
            attrs: {
              visible: _vm.dimensionsDialog.visible,
              uuid: _vm.dimensionsDialog.uuid,
              "single-weight": _vm.dimensionsDialog.singleWeight,
              dimension: _vm.dimensionsDialog.dimension,
              "open-imperial": _vm.openImperial
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.dimensionsDialog, "visible", $event)
              },
              sizeData: _vm.sizeDataHandler,
              close: function($event) {
                _vm.dimensionsDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }